
import api from '../BrandOnBoarding/api';

// Simple template service class
// export class ReportTemplateService {

//  // Get all templates for current user
//  static async getTemplates(reportType = null, user_id = null) {
//   if (!user_id) throw new Error('user_id is required');
//   if (!reportType) throw new Error('report_type is required');
//   const params = reportType ? `?report_type=${reportType}&user_id=${user_id}` : '';
//   const response = await api.get(`/llm-reporting/templates${params}`);
//   return response.data;
//  }

//  // Get specific template with full configuration
//  static async getTemplate(templateId, user_id) {
//   const response = await api.get(`/llm-reporting/templates/${templateId}?user_id=${user_id}`);
//   return response.data;
//  }

//  // Create new template
//  static async createTemplate(templateData) {
//   const response = await api.post('/llm-reporting/templates', templateData);
//   return response.data;
//  }

//  // Update existing template
//  static async updateTemplate(templateId, templateData) {
//   const response = await api.patch(`/llm-reporting/templates/${templateId}`, templateData);
//   return response.data;
//  }

//  // Delete template
//  static async deleteTemplate(templateId, user_id) {
//   const response = await api.delete(`/llm-reporting/templates/${templateId}?user_id=${user_id}`);
//   return response.data;
//  }

//  // Clone template with new name
//  static async cloneTemplate(templateId, newTemplateName) {
//   const response = await api.post(`/llm-reporting/templates/${templateId}/clone`, {
//    template_name: newTemplateName
//   });
//   return response.data;
//  }
// }

export class ReportTemplateService {

 // Get all templates for current user
 static async getTemplates(reportType = null, user_id = null) {
  try {
   if (!user_id) throw new Error('user_id is required');
   if (!reportType) throw new Error('report_type is required');
   const params = `?report_type=${reportType}&user_id=${user_id}`;
   const response = await api.get(`/llm-reporting/templates${params}`);
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || error.message || 'Failed to fetch templates';
   throw new Error(message);
  }
 }

 // Get specific template with full configuration
 static async getTemplate(templateId, user_id) {
  try {
   const response = await api.get(`/llm-reporting/templates/${templateId}?user_id=${user_id}`);
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || 'Failed to fetch template';
   throw new Error(message);
  }
 }

 // Create new template
 static async createTemplate(templateData) {
  try {
   const response = await api.post('/llm-reporting/templates', templateData);
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || 'Failed to create template';
   throw new Error(message);
  }
 }

 // Update existing template
 static async updateTemplate(templateId, templateData) {
  try {
   const response = await api.patch(`/llm-reporting/templates/${templateId}`, templateData);
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || 'Failed to update template';
   throw new Error(message);
  }
 }

 // Delete template
 static async deleteTemplate(templateId, user_id) {
  try {
   const response = await api.delete(`/llm-reporting/templates/${templateId}?user_id=${user_id}`);
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || 'Failed to delete template';
   throw new Error(message);
  }
 }

 // Clone template with new name
 static async cloneTemplate(templateId, newTemplateName, user_id) {
  try {
   const response = await api.post(`/llm-reporting/templates/${templateId}/clone`, {
    template_name: newTemplateName,
    user_id: user_id
   });
   return response.data;
  } catch (error) {
   const message = error?.response?.data?.message || 'Failed to clone template';
   throw new Error(message);
  }
 }
}

// Helper class for template processing (unchanged)
export class TemplateProcessor {

 // Save current activeSequence as template
 static async saveTemplate({
  templateName,
  description,
  reportType,
  activeSequence,
  user_id,
  show_change_data = false
 }) {

  // Validate inputs
  if (!templateName || !templateName.trim()) {
   throw new Error('Template name is required');
  }

  if (!user_id) {
   throw new Error('User ID is required');
  }

  if (!reportType) {
   throw new Error('Report type is required');
  }

  if (!Array.isArray(activeSequence) || activeSequence.length === 0) {
   throw new Error('No configuration found');
  }

  // Check if at least one item is active
  const hasActiveItems = activeSequence.some(section =>
   section.config && section.config.some(item => item.is_active)
  );

  if (!hasActiveItems) {
   throw new Error('At least one configuration item must be active');
  }

  const templateData = {
   template_name: templateName.trim(),
   description: description?.trim() || null,
   report_type: reportType,
   config_data: activeSequence,
   user_id,
   show_change_data
  };

  return await ReportTemplateService.createTemplate(templateData);
 }

 // Load template and return activeSequence
 static async loadTemplate(templateId, user_id) {
  const template = await ReportTemplateService.getTemplate(templateId, user_id);
  return {
   activeSequence: template.config_data,
   template: {
    id: template.id,
    name: template.template_name,
    description: template.description,
    reportType: template.report_type,
    createdAt: template.created_at,
    show_change_data: template.show_change_data
   }
  };
 }

 // Get template summary for display
 static getTemplateSummary(activeSequence) {
  if (!Array.isArray(activeSequence)) return 'Invalid configuration';

  const activeSections = activeSequence.filter(section =>
   section.config && section.config.some(item => item.is_active)
  ).length;

  const totalItems = activeSequence.reduce((total, section) =>
   total + (section.config ? section.config.length : 0), 0
  );

  const activeItems = activeSequence.reduce((total, section) =>
   total + (section.config ? section.config.filter(item => item.is_active).length : 0), 0
  );

  return `${activeSections}/${activeSequence.length} sections, ${activeItems}/${totalItems} items active`;
 }

 // Validate template configuration
 static validateTemplate(activeSequence, templateName) {
  if (!templateName || !templateName.trim()) {
   return 'Template name is required';
  }

  if (!Array.isArray(activeSequence) || activeSequence.length === 0) {
   return 'No configuration sections found';
  }

  const hasActiveItems = activeSequence.some(section =>
   section.config && section.config.some(item => item.is_active)
  );

  if (!hasActiveItems) {
   return 'At least one configuration item must be active';
  }

  return null; // Valid
 }
}

// Export both classes
export default ReportTemplateService;